/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
function parseLine(line) {
	return line.split(/(\[.*?\]|\(.*?\))/g)
		.map(item => item.trim())
		.filter(item => item != "");
}

function genID() {
	return `${
		Date.now().toString(36)
	}${
		Math.random().toString(36).slice(2)
	}`;
}

const ruler = document.createElement('span');

ruler.style.visibility = 'hidden';
ruler.style.position = 'absolute';
ruler.style.whiteSpace = 'pre';

document.body.appendChild(ruler);

function resizeInput(input) {
  ruler.style.font = getComputedStyle(input).font;
  ruler.textContent = input.value || input.placeholder || '';

  input.style.width = `${ruler.offsetWidth + 20}px`;
}

function renderLine(line, index) {
	const parts = parseLine(line);

	const lineWrapper = document.createElement('div');
	lineWrapper.classList.add('tk-blk-question-fill-line-wrapper')

	const p = document.createElement('p');
	p.classList.add('tk-blk-question-fill-line');

	const number = document.createElement('span');
	number.classList.add('tk-blk-question-number');

	let hint = null;

	p.appendChild(number);

	parts.forEach(part => {
		if (part.startsWith('[') && part.endsWith(']')) {
			const raw = part.slice(1, -1).trim();

			const answers = raw
				.split('/')
				.map(a => a.trim());

			const input = document.createElement('input');
			input.type = 'text';

			input.classList.add('tk-blk-input-text');

			input.addEventListener('input', () => resizeInput(input));

			input.dataset.answers = JSON.stringify(answers);
			input.dataset.question = genID();

			p.appendChild(input);
		} else if (part.startsWith('(') && part.endsWith(')')) {
			const raw = part.slice(1, -1).trim();

			const hintPlaceholder = '[.]';

			hint = document.createElement('div');

			hint.textContent = hintPlaceholder;

			hint.addEventListener('click', () => {
				if (hint.textContent === hintPlaceholder) {
					hint.textContent = `[${raw}]`;
				} else {
					hint.textContent = hintPlaceholder;
				}
			});

			hint.classList.add('tk-blk-fill-hint');
		} else {
			p.appendChild(document.createTextNode(part));
		}
	});

	lineWrapper.appendChild(p);

	if (hint) {
		lineWrapper.appendChild(hint);
	}

	return lineWrapper;
}

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.tk-blk-question-fill');

	blocks.forEach(block => {
		const imageUrl = block.dataset.image;
		const raw = block.dataset.raw;
		const lines = raw.split('\n').filter(line => line.trim() !== '');

		block.innerHTML = '';

		if (imageUrl) {
			const img = document.createElement('img');
			
			img.src = imageUrl;
			img.classList.add('tk-blk-fill-image');
			
			const imgDiv = document.createElement('div');

			imgDiv.classList.add('tk-blk-fill-img-container')
			imgDiv.appendChild(img);
			
			block.appendChild(imgDiv);
		}

		lines.forEach((line, index) => {
			block.appendChild(renderLine(line, index));
		});

		block.evaluateBlock = () => {
			const inputs = block.querySelectorAll('input');

			let total = 0;
			let correct = 0;

			inputs.forEach(input => {
				total++;

				const userValue = input.value.trim().toLowerCase();
				const answers = JSON.parse(input.dataset.answers)
					.map(a => a.toLowerCase());

				if (answers.includes(userValue)) {
					input.classList.remove('tk-blk-input-text-wrong');
					input.classList.add('tk-blk-input-text-ok');
					correct++;
				} else {
					input.classList.remove('tk-blk-input-text-ok');
					input.classList.add('tk-blk-input-text-wrong');
				}
			});

			return { correct, total };
		};
	});
});
/* eslint-enable no-console */
